import { useMemo } from "react";
import PropTypes from "prop-types";
import { Card } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";

function DeviceTable({ clientId, deviceIds, selectedDevice, onDeviceSelect }) {
  const tableData = useMemo(() => {
    const columns = [
      { Header: "#", accessor: "number" },
      { Header: "Device ID", accessor: "deviceId" },
    ];

    const rows =
      deviceIds?.map((deviceId, index) => ({
        deviceId,
        number: index + 1,
        onClick: () => onDeviceSelect(deviceId),
      })) || [];

    return { columns, rows };
  }, [deviceIds, onDeviceSelect]);

  return (
    <Card>
      <MDBox
        mx={2}
        mt={-3}
        py={3}
        px={2}
        variant="gradient"
        bgColor="info"
        borderRadius="lg"
        coloredShadow="info"
      >
        <MDTypography variant="h6" color="white">
          Client Data ID: {clientId}
        </MDTypography>
      </MDBox>
      <MDBox pt={3}>
        <DataTable
          table={tableData}
          isSorted={false}
          isDraggable={false}
          entriesPerPage={false}
          showTotalEntries={false}
          noEndBorder
          activeRow={selectedDevice}
        />
      </MDBox>
    </Card>
  );
}

DeviceTable.propTypes = {
  clientId: PropTypes.string,
  deviceIds: PropTypes.arrayOf(PropTypes.string),
  selectedDevice: PropTypes.string,
  onDeviceSelect: PropTypes.func.isRequired,
};

export default DeviceTable;
